

export const validaLargoPayment = (payment) => {

    if (payment && typeof payment === 'string') {
        if (payment.length === 9) {
            payment = payment.substring(0, payment.length - 2);
        }
        if(payment.length === 8){
            payment = payment.substring(0, payment.length - 1);
        }
        return parseInt(payment)
    }


}

export const validarPalabrasNoPermititas = (text) => {
    const palabrasNoPermitidas = ["na", "NA", "Na", "nA"];
    const contienePalabraProhibida = palabrasNoPermitidas.some(
        (palabra) => text.includes(palabra)
    );
    return contienePalabraProhibida ? "" : text;
}


export const sanitizarInputNumerico = (input) => {
    if (typeof input !== "string" || input.length === 0) {
        return "";
    }

    // Usar una expresión regular para eliminar todo excepto números
    const sanitizedValue = input.replace(/[^0-9]/g, "");

    return sanitizedValue;
};
